import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { map, catchError, of } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const authGuardsGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.checkSession().pipe(
    map(isValid => {
      if (isValid) return true;
      return router.parseUrl('/login');
    }),
    catchError(() => {
      return of(router.parseUrl('/login'));
    })
  );
  
};